import base from "./bookingBase.json";

export const LANGS = ["es", "ca", "en", "fr"];
export const LANG_NAMES = { es: "Castellano", ca: "Català", en: "English", fr: "Français" };

// Idioma por defecto de la empresa (perfil), para quien llega sin ?lang y con un
// navegador en un idioma que no tenemos. Lo fija src/lib/brand.js al cargar la marca.
let defaultLang = "es";
export function setDefaultLang(lang) {
  if (LANGS.includes(lang)) defaultLang = lang;
}

export function pickLang(search) {
  const q = new URLSearchParams(search || "").get("lang");
  if (LANGS.includes(q)) return q;
  const nav = (typeof navigator !== "undefined" ? navigator.language : "").slice(0, 2).toLowerCase();
  return LANGS.includes(nav) ? nav : defaultLang;
}

export function t(lang, key, vars = {}) {
  const dict = base[lang] || base.es;
  let s = dict[key] ?? base.es[key] ?? key;
  for (const [k, v] of Object.entries(vars)) s = s.split(`{${k}}`).join(String(v));
  return s;
}

export const money = (lang, n) =>
  new Intl.NumberFormat(lang === "en" ? "en-GB" : `${lang}-ES`, { style: "currency", currency: "EUR" }).format(Number(n || 0));

export const longDate = (lang, iso) =>
  iso ? new Intl.DateTimeFormat(lang === "en" ? "en-GB" : `${lang}-ES`, { day: "numeric", month: "long", year: "numeric" })
    .format(new Date(`${iso}T12:00:00`)) : "";
